import { StyledIllustration } from "../StyledIllustration";

const InteractiveIllustration = () => {
    return (
        <StyledIllustration
            fileName={"template_a.svg"}
            xmlns="http://www.w3.org/2000/svg"
            width="90"
            height="60"
            fill="none"
            viewBox="0 0 90 60"
        >
            <rect x="26.25" y="15.75" width="41.25" height="30" rx="3" fill="#006EFA" />
            <rect x="18" y="42" width="24.75" height="12" rx="6" fill="#333333" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M23.6221 46.2222C23.3098 46.2222 23.0566 46.4753 23.0566 46.7876V49.2757C23.0566 49.588 23.3098 49.8412 23.6221 49.8412H26.143C26.4553 49.8412 26.7085 49.588 26.7085 49.2757V46.7876C26.7085 46.4753 26.4553 46.2222 26.143 46.2222H23.6221ZM27.3999 47.0434C27.3191 47.0955 27.2703 47.185 27.2703 47.2811V48.7822C27.2703 48.8784 27.3191 48.9679 27.3999 49.0199L28.239 49.5604C28.4271 49.6816 28.6748 49.5466 28.6748 49.3228V46.7406C28.6748 46.5168 28.4271 46.3817 28.239 46.5029L27.3999 47.0434Z"
                fill="white"
            />
            <path
                d="M34.0123 46.2221C34.0123 45.7225 34.3896 45.3174 34.8551 45.3174C35.3205 45.3174 35.6978 45.7225 35.6978 46.2221V47.7301C35.6978 48.2298 35.3205 48.6348 34.8551 48.6348C34.3896 48.6348 34.0123 48.2298 34.0123 47.7301V46.2221Z"
                fill="white"
            />
            <path
                d="M33.1696 47.1269C33.3247 47.1269 33.4505 47.2619 33.4505 47.4285V47.7301C33.4505 48.5629 34.0793 49.238 34.8551 49.238C35.6308 49.238 36.2596 48.5629 36.2596 47.7301V47.4285C36.2596 47.2619 36.3854 47.1269 36.5405 47.1269C36.6957 47.1269 36.8215 47.2619 36.8215 47.4285V47.7301C36.8215 48.7939 36.0886 49.6739 35.1353 49.8199C35.1357 49.8269 35.136 49.834 35.136 49.8412V50.4443C35.136 50.6109 35.0102 50.7459 34.8551 50.7459C34.6999 50.7459 34.5741 50.6109 34.5741 50.4443V49.8412C34.5741 49.834 34.5744 49.8269 34.5748 49.8199C33.6216 49.6739 32.8887 48.7939 32.8887 47.7301V47.4285C32.8887 47.2619 33.0144 47.1269 33.1696 47.1269Z"
                fill="white"
            />
            <rect x="18" y="42" width="24.75" height="12" rx="6" className="Tone1" fill="#333333" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M23.6221 46.2222C23.3098 46.2222 23.0566 46.4753 23.0566 46.7876V49.2757C23.0566 49.588 23.3098 49.8412 23.6221 49.8412H26.143C26.4553 49.8412 26.7085 49.588 26.7085 49.2757V46.7876C26.7085 46.4753 26.4553 46.2222 26.143 46.2222H23.6221ZM27.3999 47.0434C27.3191 47.0955 27.2703 47.185 27.2703 47.2811V48.7822C27.2703 48.8784 27.3191 48.9679 27.3999 49.0199L28.239 49.5604C28.4271 49.6816 28.6748 49.5466 28.6748 49.3228V46.7406C28.6748 46.5168 28.4271 46.3817 28.239 46.5029L27.3999 47.0434Z"
                className="Tone8"
                fill="white"
            />
            <path
                d="M34.0123 46.2221C34.0123 45.7225 34.3896 45.3174 34.8551 45.3174C35.3205 45.3174 35.6978 45.7225 35.6978 46.2221V47.7301C35.6978 48.2298 35.3205 48.6348 34.8551 48.6348C34.3896 48.6348 34.0123 48.2298 34.0123 47.7301V46.2221Z"
                className="Tone8"
                fill="white"
            />
            <path
                d="M33.1696 47.1269C33.3247 47.1269 33.4505 47.2619 33.4505 47.4285V47.7301C33.4505 48.5629 34.0793 49.238 34.8551 49.238C35.6308 49.238 36.2596 48.5629 36.2596 47.7301V47.4285C36.2596 47.2619 36.3854 47.1269 36.5405 47.1269C36.6957 47.1269 36.8215 47.2619 36.8215 47.4285V47.7301C36.8215 48.7939 36.0886 49.6739 35.1353 49.8199C35.1357 49.8269 35.136 49.834 35.136 49.8412V50.4443C35.136 50.6109 35.0102 50.7459 34.8551 50.7459C34.6999 50.7459 34.5741 50.6109 34.5741 50.4443V49.8412C34.5741 49.834 34.5744 49.8269 34.5748 49.8199C33.6216 49.6739 32.8887 48.7939 32.8887 47.7301V47.4285C32.8887 47.2619 33.0144 47.1269 33.1696 47.1269Z"
                className="Tone8"
                fill="white"
            />
            <path
                d="M36.1708 32.9711C36.0599 31.9007 36.122 30.7479 36.5277 29.7385C37.2766 27.875 39.664 25.2356 41.7967 24.63C43.4994 24.1466 45.7158 24.3524 47.0912 25.568C47.6126 26.0288 48.0853 26.6011 48.4849 27.1675C49.5928 28.7378 49.8986 30.6133 49.4112 32.4519C48.6815 35.205 43.6452 37.1105 40.9044 36.882C38.9877 36.7223 36.3817 35.0085 36.1708 32.9711Z"
                stroke="white"
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M51.8568 24.0955C53.7571 23.9738 56.5632 25.2952 57.0723 27.2887C57.9395 30.6845 57.3935 33.1469 54.5156 35.6494C53.1918 36.8005 49.0064 37.249 47.4792 36.2424C45.3022 34.8075 43.8997 32.3985 44.1854 29.7421C44.491 26.8998 49.1392 24.2696 51.8568 24.0955Z"
                stroke="white"
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M58.9157 36.0225L64.4799 37.8016C64.6979 37.8713 64.8182 38.1046 64.7485 38.3227C64.7137 38.4315 64.6355 38.5211 64.5325 38.5704L62.3679 39.6056C62.1971 39.6873 62.0594 39.825 61.9777 39.9958L60.9425 42.1604C60.8437 42.3669 60.5962 42.4543 60.3896 42.3555C60.2866 42.3062 60.2084 42.2166 60.1737 42.1078L58.3946 36.5436C58.3248 36.3255 58.4451 36.0922 58.6632 36.0225C58.7453 35.9962 58.8335 35.9962 58.9157 36.0225Z"
                fill="#FF9DFF"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M20.5917 22.9555L19.841 29.8305C19.8116 30.0999 19.5694 30.2945 19.2999 30.2651C19.1655 30.2504 19.0431 30.1809 18.9616 30.073L17.2497 27.8062C17.1146 27.6273 16.9223 27.5001 16.7049 27.4456L13.9494 26.7555C13.6865 26.6897 13.5268 26.4232 13.5926 26.1602C13.6255 26.029 13.711 25.9172 13.829 25.8512L19.8642 22.474C20.1007 22.3416 20.3997 22.426 20.5321 22.6626C20.5819 22.7516 20.6028 22.854 20.5917 22.9555Z"
                fill="#FF3D23"
            />
            <rect
                x="62.5742"
                y="8.70569"
                width="14.8553"
                height="14.5839"
                rx="1.92175"
                transform="rotate(12 62.5742 8.70569)"
                fill="#FFD357"
            />
            <path
                d="M64.357 15.5068C65.2369 14.6313 66.1969 13.7292 67.2963 13.5671C67.3774 13.5552 67.4748 13.5566 67.5132 13.6382C67.5321 13.6785 67.5311 13.7292 67.5281 13.7771C67.4839 14.4789 67.1184 15.1305 67.0295 15.8305C67.0241 15.8731 67.0205 15.9201 67.0408 15.9531C67.0731 16.0055 67.1426 15.9917 67.1977 15.9709C67.6069 15.8164 67.9881 15.5409 68.4017 15.4115C68.8153 15.2821 69.3043 15.3401 69.5317 15.7403C69.6762 15.9945 69.69 16.3422 69.8458 16.5861C69.9836 16.8018 70.2161 16.9051 70.4493 16.9269C70.6824 16.9487 70.9203 16.8983 71.1558 16.8549C72.1361 16.6741 73.1855 16.6265 74.001 17.2026"
                stroke="#333333"
                strokeLinecap="round"
            />
            <path d="M65.7658 19.4005L70.0689 20.3938" stroke="#333333" strokeLinecap="round" />
        </StyledIllustration>
    );
};

const PanelIllustration = () => {
    return (
        <StyledIllustration
            fileName={"template_a.svg"}
            xmlns="http://www.w3.org/2000/svg"
            width="90"
            height="60"
            fill="none"
            viewBox="0 0 90 60"
        >
            <rect x="26.25" y="12.75" width="9" height="7.5" rx="1.5" fill="#006EFA" />
            <rect x="36.75" y="12.75" width="9" height="7.5" rx="1.5" fill="#006EFA" />
            <rect x="47.25" y="12.75" width="9" height="7.5" rx="1.5" fill="#006EFA" />
            <rect x="57.75" y="12.75" width="9" height="7.5" rx="1.5" fill="#006EFA" />
            <rect x="25.9609" y="21.75" width="41.25" height="26.25" rx="3" fill="#FF9DFF" />
            <circle cx="46.8105" cy="34.5" r="6" fill="white" />
            <path
                d="M49.1436 33.924C49.588 34.1806 49.588 34.8221 49.1436 35.0787L46.1436 36.8107C45.6991 37.0673 45.1436 36.7466 45.1436 36.2334V32.7693C45.1436 32.2561 45.6991 31.9353 46.1436 32.1919L49.1436 33.924Z"
                fill="#006EFA"
            />
            <rect
                x="52.7578"
                y="41.903"
                width="21.2474"
                height="11.1638"
                rx="5.5819"
                transform="rotate(-10.5691 52.7578 41.903)"
                fill="#FF3D23"
            />
            <path
                d="M57.9028 44.5304L58.8045 44.3622L59.4314 47.7223L60.8981 47.4486L61.0562 48.2962L58.6879 48.7381L57.9028 44.5304ZM60.8437 43.9817L61.7514 43.8123L62.5365 48.02L61.6288 48.1893L60.8437 43.9817ZM65.3786 47.4897L64.6333 47.6287L62.2312 43.7228L63.199 43.5422L64.7672 46.1793L65.2788 43.1541L66.2165 42.9792L65.3786 47.4897ZM67.4813 47.0973L66.6962 42.8897L69.1727 42.4276L69.3253 43.2451L67.7504 43.5389L67.9096 44.3925L69.3463 44.1244L69.4943 44.9179L68.0577 45.1859L68.2304 46.1116L69.8173 45.8155L69.9698 46.633L67.4813 47.0973Z"
                fill="white"
            />
            <path
                d="M16.1452 20.3286C16.3276 19.5592 17.4224 19.5592 17.6048 20.3286L18.1336 22.5596C18.1991 22.8355 18.4145 23.0509 18.6904 23.1164L20.9214 23.6452C21.6908 23.8276 21.6908 24.9224 20.9214 25.1048L18.6904 25.6336C18.4145 25.6991 18.1991 25.9145 18.1336 26.1904L17.6048 28.4214C17.4224 29.1908 16.3276 29.1908 16.1452 28.4214L15.6164 26.1904C15.5509 25.9145 15.3355 25.699 15.0596 25.6336L12.8286 25.1048C12.0592 24.9224 12.0592 23.8276 12.8286 23.6452L15.0596 23.1164C15.3355 23.0509 15.551 22.8355 15.6164 22.5596L16.1452 20.3286Z"
                fill="#FFD357"
            />
        </StyledIllustration>
    );
};

export const CustomRoomIllustration = () => {
    return (
        <StyledIllustration
            fileName={"template_a.svg"}
            xmlns="http://www.w3.org/2000/svg"
            width="90"
            height="60"
            fill="none"
            viewBox="0 0 90 60"
        >
            <rect
                x="15.75"
                y="14.2913"
                width="24"
                height="24"
                rx="3"
                transform="rotate(-15 15.75 14.2913)"
                fill="#FF9DFF"
            />
            <rect x="25.5" y="15.75" width="36" height="30" rx="3" fill="#FFD357" />
            <path d="M54.7607 38.2499L33.0107 38.2499" stroke="#333333" strokeWidth="1.5" strokeLinecap="round" />
            <path d="M54.7607 30.7499L33.0107 30.7499" stroke="#333333" strokeWidth="1.5" strokeLinecap="round" />
            <path d="M54.7607 23.2499L33.0107 23.2499" stroke="#333333" strokeWidth="1.5" strokeLinecap="round" />
            <circle cx="48.1465" cy="23.0118" r="2.25" transform="rotate(-180 48.1465 23.0118)" fill="white" />
            <circle cx="48.1465" cy="38.2499" r="2.25" transform="rotate(-180 48.1465 38.2499)" fill="#FF3D23" />
            <circle cx="37.8799" cy="30.7499" r="2.25" transform="rotate(-180 37.8799 30.7499)" fill="#006EFA" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M65.2883 28.4405C65.7234 25.5739 68.4001 23.6027 71.2667 24.0379V24.0379C74.1334 24.473 76.1045 27.1496 75.6694 30.0163V30.0163C75.2343 32.883 72.5576 34.8541 69.691 34.419V34.419C66.8243 33.9838 64.8532 31.3072 65.2883 28.4405V28.4405Z"
                fill="#006EFA"
            />
            <path
                d="M68.3507 29.0903L69.6954 30.942L73.1821 27.9747"
                stroke="white"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </StyledIllustration>
    );
};

/**
 * Illustrations map for room templates
 * Maps template illustration names to their respective components
 */
export const roomIllustrationsMap: Record<string, React.FC> = {
    InteractiveIllustration,
    PanelIllustration,
};
